import React, { useRef, useEffect } from 'react';

import './styles.scss';

export interface CheckboxProps {
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  indeterminate?: boolean;
}

export function Checkbox({ isChecked, onChange, disabled = false, indeterminate = false }: CheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <label className="Checkbox-wrapper">
      <input 
        ref={inputRef}
        type="checkbox" 
        checked={isChecked} 
        onChange={onChange} 
        disabled={disabled} 
        className="Checkbox-input" 
      />
      <span className="Checkbox-visual">
        {indeterminate ? (
          <svg className="Checkbox-indeterminate" viewBox="0 0 12 12" fill="none">
            <path d="M3 6H9" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        ) : isChecked ? (
          <svg className="Checkbox-checkmark" viewBox="0 0 12 12" fill="none">
            <path d="M2 6L5 9L10 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : null}
      </span>
    </label>
  );
}
